module.exports = __webpack_public_path__ + "img/7.eda3fc36.jpg";